export const PROJECT_PATH = '/jira/servicedesk/projects';
export const HELPCENTER_PATH = '/jira/helpcenter/projects';
